import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { CreateTerminalSchema } from '../schemes/CreiacaoDeTerminais';

export default function ModalEdicao({ open, onClose, onSave, terminal, isLoading }) {
    // Estado local do formulário, inicializado com os dados do terminal
    const [formData, setFormData] = useState({
        id: '',
        nm_maquina: '',
        operador: '',
        ativo: 'S',
        cod_maquina: ''
    });

    const [erroNomeTerminal, seterroNomeTerminal] = useState(false);
    const [erroNomeTerminalMessage, seterroNomeTerminalMessage] = useState('');

    const [erroCodTerminal, seterroCodTerminal] = useState(false);
    const [erroCodTerminalMessage, seterroCodTerminalMessage] = useState('');


    // Popula o formulário quando o terminal a ser editado muda
    useEffect(() => {
        if (terminal) {
            setFormData({
                id: terminal.id,
                nm_maquina: terminal.nm_maquina || '',
                operador: terminal.operador || '',
                ativo: terminal.ativo || 'S',
                cod_maquina: terminal.cod_maquina || ''
            });
        }
    }, [terminal]);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let nm_maquina = formData.nm_maquina;
        let cod_maquina = formData.cod_maquina;

        const result = CreateTerminalSchema.safeParse({ nm_maquina, cod_maquina });
        if (!result.success) {
            const errors = result.error.format();

            if (errors.nm_maquina?._errors?.length) {
                seterroNomeTerminal(true);
                seterroNomeTerminalMessage(errors.nm_maquina._errors[0]);
            } else {
                seterroNomeTerminal(false);
                seterroNomeTerminalMessage('');
            }

            if (errors.cod_maquina?._errors?.length) {
                seterroCodTerminalMessage(errors.cod_maquina._errors[0]);
                seterroCodTerminal(true);
            } else {
                seterroCodTerminalMessage('');
                seterroCodTerminal(false);
            }

            return;
        }

        onSave(formData);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Editar Máquina</DialogTitle>
            <Box
                component="form"
                onSubmit={handleSubmit}
            >
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                fullWidth
                                name="cod_maquina"
                                value={formData.cod_maquina}
                                onChange={handleChange}
                                label="Código da Máquina"
                                required
                                error={erroCodTerminal}
                                helperText={erroCodTerminalMessage}
                                InputProps={{
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                FormHelperTextProps={{
                                    sx: { fontSize: '0.9rem', color: 'red', fontWeight: 'bold' }
                                }}
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                fullWidth
                                autoComplete="off"
                                name="nm_maquina"
                                value={formData.nm_maquina}
                                onChange={handleChange}
                                label="Nome da Máquina"
                                required
                                error={erroNomeTerminal}
                                helperText={erroNomeTerminalMessage}
                                InputProps={{
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                FormHelperTextProps={{
                                    sx: { fontSize: '0.9rem', color: 'red', fontWeight: 'bold' }
                                }}
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                name="operador"
                                value={formData.operador}
                                onChange={handleChange}
                                label="Operador"
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                            >
                                <MenuItem value="stone">Stone</MenuItem>
                                <MenuItem value="cielo">Cielo</MenuItem>
                                <MenuItem value="getnet">Get Net</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                name="ativo"
                                value={formData.ativo}
                                onChange={handleChange}
                                label="Status"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                            >
                                <MenuItem value="S">Ativo</MenuItem>
                                <MenuItem value="N">Inativo</MenuItem>
                                <MenuItem value="M">Manutenção</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">Cancelar</Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        disabled={isLoading}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}